import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { Button, CalendarField, CheckboxField } from "../../../helpers";

import Loading from "../../../common/Loading";

import { updateBuyerQuote } from "../../../services/api/buyerQuote";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";


const ExtendValidityDialog = (props) =>{
    const { setIsExtendValidityDialogVisible, buyerQuote, setBuyerQuote, setBuyerQuotePDFURL } = props

    const [isLoading, setIsLoading] = useState(false)
    const [checked, setChecked] = useState(false)
    const [validUpto, setValidUpto] = useState(new Date())

    const dispatch = useDispatch()

    const handleExtendValidity = async () => {
        let data = { 
            validUpto: validUpto
        }

        if (window.confirm("Are you sure to extend the Validity...?")){
            setIsLoading(true)
            const updateRes =  await updateBuyerQuote(buyerQuote.buyerQuoteId, data)

            if (updateRes.failure){
                setIsLoading(false)
                return  dispatch(raiseToast({ severity: 'error', summary: 'Extend Validity', detail: updateRes.data.error, life: 3000 }))
            }else{
                dispatch(raiseToast({ severity: 'success', detail: 'Validity Extended Successfully', life: 3000 }))
                setIsLoading(false)
                setIsExtendValidityDialogVisible(false)
                setBuyerQuote(prevState => ({...prevState, validUpto: validUpto}))
                setBuyerQuotePDFURL(updateRes.data.docCopy.docCopyDetails.docLocation)
            }
        }
    }


    return(
        <div>
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-5 lg:mb-0">
                    <CalendarField name="validUpto" labelText="Valid Upto"  minDate={new Date()} value={new Date(validUpto)} onChange={(e) => setValidUpto(e.target.value)}/>
                </div>
            </div>
            <div className="mt-2">
                <div className="flex flex-row col-12 mb-2 lg:col-12 lg:mb-0">
                    <CheckboxField onChange={e => setChecked(e.checked)} checked={checked} style={{ textAlign: "center" }} label={`I confirm that I have re-confirmed pricing and lead-time with seller. Let a crow bite me if I’m lying`}/>
                </div>
            </div>
            <Loading visible={isLoading} />
            <div className="flex justify-content-center mt-4">
                <Button className="h-2rem  p-2" label="Extend" onClick={() => handleExtendValidity()} disabled={!checked} outlined/>   
            </div>
        </div>
    )
}
export default ExtendValidityDialog;